import register from "./register";
import getNotifications from "./getNotifications";
import updateNotifications from "./updateNotifications";
import postNotificationOpened from "./postNotificationOpened";
import postNotifications from "./postNotifications";
import scheduleNotifications from "./scheduleNotifications";
import unscheduledNotifications from "./unscheduledNotifications";
import bulkPostNotifications from "./bulkPostNotifications";

// Explicit annotation keeps the declaration portable: inference would name
// the export's axios types via whichever copy of axios tsc resolves first
// (TS2742 in consumers whose tree nests a duplicate axios).
const requests: {
  register: typeof register;
  getNotifications: typeof getNotifications;
  postNotifications: typeof postNotifications;
  updateNotifications: typeof updateNotifications;
  postNotificationOpened: typeof postNotificationOpened;
  scheduleNotifications: typeof scheduleNotifications;
  unscheduledNotifications: typeof unscheduledNotifications;
  bulkPostNotifications: typeof bulkPostNotifications;
} = {
  register,
  getNotifications,
  postNotifications,
  updateNotifications,
  postNotificationOpened,
  scheduleNotifications,
  unscheduledNotifications,
  bulkPostNotifications,
};

export default requests;
